import { useState } from 'react';
import { Popover } from 'foundations-components/transitional/components/Popover';
import AllEventsFilterLabel from './AllEventsFilterLabel';
import AllEventsFilterDisplayLabel from './AllEventsFilterDisplayLabel';
import { toEventDateInterval, toObjectSegFilterStrict
// @ts-expect-error untyped import
} from '../../event-date-interval-utils';
// @ts-expect-error untyped import
import SnowflakeFilterTile from '../SnowflakeFilterTile';
import { getIsUngated, useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
// @ts-expect-error untyped import
import SnowflakeFilterWrapper from '../SnowflakeFilterWrapper';
import { SNOWFLAKE_FILTER_FAMILY
// @ts-expect-error untyped import
} from '../../xo-filter-utils';
import { View } from 'foundations-components/components/View';
import { getIsUngatedToSnowflakePropertyFilterMigration } from '../../../../utils/filter-utils';
import { NewEventDateFilterPanel } from './NewEventDateFilterPanel';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const EventDateIntervalFilterTile = ({
  value: initialValue,
  readOnly,
  onChange
}) => {
  const [editing, setEditing] = useState(false);
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const filter = toObjectSegFilterStrict(initialValue, SNOWFLAKE_FILTER_FAMILY, gate => getIsUngated(gate, userGates), true);
  const handleEdit = () => {
    setEditing(true);
  };
  const handleFilterChange = nextValue => {
    onChange(toEventDateInterval(nextValue));
    setEditing(false);
  };
  const renderFilter = () => {
    if (!userGates || !userGates.length) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }
    const FilterLabelComponent = getIsUngatedToSnowflakePropertyFilterMigration(userGates) ? AllEventsFilterDisplayLabel : AllEventsFilterLabel;
    return /*#__PURE__*/_jsx(SnowflakeFilterWrapper, {
      readOnly: readOnly,
      highlighted: editing,
      onEdit: handleEdit,
      children: /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(FilterLabelComponent, {
          filter: filter
        })
      })
    });
  };
  const renderEditPanel = () => /*#__PURE__*/_jsx(NewEventDateFilterPanel, {
    filter: filter,
    onDone: ({
      draftFilter
    }) => handleFilterChange(draftFilter),
    onCancel: () => setEditing(false)
  });
  return /*#__PURE__*/_jsx(SnowflakeFilterTile, {
    readOnly: readOnly,
    children: /*#__PURE__*/_jsx(Popover, {
      open: !readOnly && editing,
      arrowSize: "medium",
      placement: "right",
      content: /*#__PURE__*/_jsx(View, {
        padding: "500",
        inlineSize: "300px",
        children: renderEditPanel()
      }),
      children: renderFilter()
    })
  });
};